var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 258,
    viewBox: "0 0 438 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_5889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 118.43C126.15 113.6 129.53 97.9601 120.55 77.0001C111.57 56.0401 90.7801 44.4701 85.1601 58.2501C79.5401 72.0301 76.1801 129.53 111 118.43Z",
    fill: "#F1F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 17.7598C116.76 11.2898 103.2 29.3398 109.94 33.8898C116.68 38.4398 130.6 25.6198 123 17.7598Z",
    fill: "#F1F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.15 97.5094C344.89 92.0194 333.34 109.099 353.33 114.059C373.32 119.019 377.1 105.369 358.15 97.5094Z",
    fill: "#F1F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74 191.33L104.11 189.33C104.11 189.33 67.1699 160.33 95.8299 140.24L96.5199 139.76C101.46 136.45 108.23 133.38 117.31 130.76C129.83 127.12 137.99 123.49 143.03 119.76L143.65 119.29C160.04 106.41 140.11 92.2902 133.81 72.6802C132.666 69.13 132.148 65.4078 132.28 61.6802C132.265 61.4638 132.265 61.2466 132.28 61.0302C133.56 36.7202 161.74 11.0302 213.73 3.31017L214.73 3.16016C231.59 0.750159 250.91 0.230171 272.61 2.25017C272.93 2.25017 273.26 2.30017 273.61 2.34017C281.137 3.06017 288.943 4.09349 297.03 5.44016C324.95 10.1302 340.12 20.3202 346.78 32.2602L347.13 32.9002C356.35 50.3102 347.85 71.2702 334.59 84.3902C334.42 84.5602 334.25 84.7302 334.07 84.8902C331.244 87.6465 328.114 90.0721 324.74 92.1202C316.24 97.2102 311.36 101.88 309.59 106.03C309.5 106.233 309.419 106.44 309.35 106.65C306.02 115.97 318.69 122.54 341.35 125.16L342.3 125.27C376.21 128.93 409.06 163.36 378.74 191.33Z",
    fill: "#F1F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 238.41C438 232.25 339.95 227.26 219 227.26C98.05 227.26 0 232.26 0 238.41C0 244.56 98.05 249.57 219 249.57C223.38 249.57 227.73 249.57 232.05 249.57C239.48 253.86 272.71 257.09 312.6 257.09C357.94 257.09 394.7 252.91 394.7 247.76C394.7 246.91 393.7 246.08 391.78 245.29C420.74 243.38 438 241 438 238.41Z",
    fill: "#087E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.69 130H126.07V227.26H183.17V130H174.69Z",
    fill: "#A77A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.87 100.109H233.53V197.369H332.57V100.109H317.87Z",
    fill: "#A77A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39 141.6H258.57V235.73H388.39V141.6Z",
    fill: "#A77A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39 141.6H325.49V235.73H388.39V141.6Z",
    fill: "#C9986C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.49 141.6L342.89 163.74H404.45L388.39 141.6H325.49Z",
    fill: "#E0AB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.02 152.75H101.53V235.73H172.02V152.75Z",
    fill: "#C9986C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24 152.75H48.8896V235.73H112.24V152.75Z",
    fill: "#E0AB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24 152.75L94.6098 174.72H32.0498L48.8898 152.75H112.24Z",
    fill: "#F5C096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24 152.75L125.4 174.72H185.29L172.02 152.75H112.24Z",
    fill: "#E0AB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59 174.72H262.58V235.73H353.59V174.72Z",
    fill: "#C9986C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.6 174.72H308.09V235.73H353.6V174.72Z",
    fill: "#E0AB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.54 188.219H325C324.56 188.219 324.125 188.133 323.718 187.964C323.312 187.796 322.943 187.549 322.632 187.238C322.321 186.927 322.074 186.558 321.905 186.151C321.737 185.745 321.65 185.309 321.65 184.869C321.653 183.983 322.007 183.133 322.635 182.507C323.263 181.881 324.114 181.529 325 181.529H339.5C340.387 181.529 341.238 181.881 341.866 182.507C342.494 183.133 342.848 183.983 342.85 184.869C342.85 185.751 342.503 186.597 341.883 187.224C341.264 187.851 340.422 188.209 339.54 188.219Z",
    fill: "#A77A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19 119.739H156.4V235.729H278.19V119.739Z",
    fill: "#E0AB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.06 141.599C242.059 143.493 241.308 145.309 239.97 146.649C239.135 147.483 238.103 148.091 236.97 148.419C236.294 148.633 235.589 148.741 234.88 148.739H199.68C198.267 148.74 196.886 148.321 195.712 147.537C194.537 146.752 193.621 145.637 193.081 144.332C192.54 143.027 192.399 141.591 192.674 140.206C192.95 138.82 193.631 137.548 194.63 136.549C194.662 136.511 194.699 136.477 194.74 136.449C196.065 135.167 197.836 134.45 199.68 134.449H234.92C235.858 134.449 236.787 134.634 237.654 134.994C238.521 135.353 239.309 135.88 239.972 136.544C240.635 137.208 241.161 137.996 241.519 138.864C241.877 139.731 242.061 140.661 242.06 141.599Z",
    fill: "#A77A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5 220.22H246.75C246.367 220.221 245.988 220.147 245.633 220.001C245.279 219.855 244.957 219.641 244.686 219.371C244.415 219.101 244.199 218.779 244.053 218.426C243.906 218.072 243.83 217.693 243.83 217.31C243.83 216.535 244.138 215.793 244.685 215.245C245.233 214.697 245.976 214.39 246.75 214.39H267.5C268.275 214.39 269.017 214.697 269.565 215.245C270.112 215.793 270.42 216.535 270.42 217.31C270.42 217.693 270.344 218.072 270.198 218.426C270.051 218.779 269.836 219.101 269.564 219.371C269.293 219.641 268.971 219.855 268.617 220.001C268.263 220.147 267.883 220.221 267.5 220.22Z",
    fill: "#F9E0CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 225.22H245.29C244.903 225.22 244.532 225.066 244.258 224.792C243.984 224.518 243.83 224.147 243.83 223.76C243.83 223.373 243.984 223.001 244.258 222.727C244.532 222.454 244.903 222.3 245.29 222.3H269C269.387 222.3 269.759 222.454 270.032 222.727C270.306 223.001 270.46 223.373 270.46 223.76C270.46 224.147 270.306 224.518 270.032 224.792C269.759 225.066 269.387 225.22 269 225.22Z",
    fill: "#F9E0CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_5889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 256.14,
    fill: "white",
    transform: "translate(0 0.929688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.d847a5e21500527df9980fe53a37782f.svg";
export { ForwardRef as ReactComponent };